import { render, staticRenderFns } from "./CompanyGeneralLinks.vue?vue&type=template&id=af3dea04&scoped=true&"
import script from "./CompanyGeneralLinks.vue?vue&type=script&lang=ts&"
export * from "./CompanyGeneralLinks.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyGeneralLinks.vue?vue&type=style&index=0&id=af3dea04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3dea04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLayout,VRow})
